export default
    {
        // url: this.$store.state.http.reportes.YYYY,
        borraEgreso: "/reportes/borraEgreso",
        borraIngreso: "/reportes/borraIngreso",
        cargaRegistros: "/reportes/subeIngresos",
        listIngresosCasf: "/reportes/listIngresosCasf",
        listEgresosCasf: "/reportes/listEgresosCasf",
        listCirugiasCasf: "/reportes/listCirugiasCasf",

        listReporteConsumo: "/reportes/listReporteConsumo",
    }
